import type { IApiError } from '~/types/api';

export const isApiErrorObject = (obj: unknown): obj is Exclude<IApiError, null | undefined | string> => {
  return typeof obj === 'object' && obj !== null && 'error' in obj;
};
